import axios from "axios";
import { BASE_URL } from "./config";

const api = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
});
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      const lastReload = sessionStorage.getItem("lastReload");

      // Reload only if not reloaded in last 2 minutes
      if (!lastReload || Date.now() - parseInt(lastReload) > 5 * 60 * 1000) {
        sessionStorage.setItem("lastReload", Date.now().toString());
        window.location.reload();
      }

      return Promise.resolve({ data: null }); // prevent throwing
    }
    return Promise.reject(error);
  }
);



export default api;